import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../../shared/permissions';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';
import hasPermissions from '../../../../utilities/hasPermissions';
import FinderVehicleAssignmentsSection from './VehicleAssignmentTab/FinderVehicleAssignmentsSection';
import VehicleAssignmentsSection from './VehicleAssignmentTab/VehicleAssignmentsSection';

const AssignVehiclesForm = ({ disabled = false }: { disabled: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);
    const company = useCompany(true);

    const showFinderAssignment =
        company?.availableModules.hasFinderVehicleManagementModules &&
        hasPermissions(company?.permissions, [permissionKind.viewFinderVehicles]);

    const tooltip = (
        <Tooltip title={t('financeProductDetails:tooltip.assignVehicles')}>
            <InfoCircleOutlined style={{ marginLeft: '4px', fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }} />
        </Tooltip>
    );

    return (
        <>
            <VehicleAssignmentsSection
                disabled={disabled}
                filter={{ companyId: company?.id }}
                header={
                    <>
                        {t('financeProductDetails:mainTitles.assignVehicles')}
                        {tooltip}
                    </>
                }
                name="variantSuiteIds"
                transferFieldProps={{
                    listStyle: {
                        // minimum width
                        width: 100,
                        height: 400,
                    },
                    titles: [
                        t('financeProductDetails:subTitles.variantsPool'),
                        t('financeProductDetails:subTitles.selectedVariants'),
                    ],
                    showSearch: true,
                }}
            />
            {showFinderAssignment && (
                <FinderVehicleAssignmentsSection
                    allowSync={hasPermissions(company?.permissions, [permissionKind.manageFinderVehicles])}
                    disabled={disabled}
                    filter={{ companyId: company?.id }}
                    header={
                        <>
                            {t('financeProductDetails:mainTitles.assignFinderVehicles')}
                            {tooltip}
                        </>
                    }
                    name="variantSuiteIds"
                    transferFieldProps={{
                        listStyle: {
                            // minimum width
                            width: 100,
                            height: 400,
                        },
                        titles: [
                            t('financeProductDetails:subTitles.finderVehiclesPool'),
                            t('financeProductDetails:subTitles.selectedFinderVehicles'),
                        ],
                        showSearch: true,
                    }}
                />
            )}
        </>
    );
};

export default AssignVehiclesForm;
